"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.progressListContainer = exports.progressGridContainer = exports.listStatusWrapper = exports.statusIconClass = exports.listNameProgressTopWrapper = exports.listNameProgressWrapper = exports.overlayRound = exports.overlay = exports.listUserLeftContainer = exports.onStageSideBar = exports.userListContainer = exports.roundImage = exports.userNameActionContainer = exports.userName = exports.userImage = exports.userImageProgressContainer = exports.itemGridContainer = void 0;

var _reactEmotion = require("react-emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var itemGridContainer =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;flex-direction:column;&.w-small{width:140px;}&.w-medium{width:256px;}&.w-large{width:348px;}&.w-mega{width:532px;}&.ON_STAGE{box-shadow:0px 0px 0px 7px ", _themeConfig.default.color.dark.saturn, ",0px 0px 0px 8px ", _themeConfig.default.color.dark.emerald, ";border-radius:1px;}&.INVITED{box-shadow:0px 0px 0px 7px ", _themeConfig.default.color.dark.saturn, ",0px 0px 0px 8px ", _themeConfig.default.color.dark.topaz, ";border-radius:1px;}&.REJECTED{box-shadow:0px 0px 0px 7px ", _themeConfig.default.color.dark.saturn, ",0px 0px 0px 8px ", _themeConfig.default.color.dark.ruby, ";border-radius:1px;}");
exports.itemGridContainer = itemGridContainer;
var userImageProgressContainer =
/*#__PURE__*/
(0, _reactEmotion.css)("height:104px;width:100%;position:relative;border-radius:3px;overflow:hidden;background:black;img{object-fit:contain;}&.w-small{height:104px;}&.w-medium{height:192px;}&.w-large{height:260px;}&.w-mega{height:400px;}");
exports.userImageProgressContainer = userImageProgressContainer;
var userImage =
/*#__PURE__*/
(0, _reactEmotion.css)("border-radius:3px;width:100%;&.w-small{height:104px;}&.w-medium{height:192px;}&.w-large{height:260px;}&.w-mega{height:400px;}");
exports.userImage = userImage;
var userName =
/*#__PURE__*/
(0, _reactEmotion.css)("font-weight:500;");
exports.userName = userName;
var userNameActionContainer =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;flex-direction:row;justify-content:space-between;align-items:center;.iconbutton{width:28px;height:28px;.Icon{width:14px;height:14px;}}");
exports.userNameActionContainer = userNameActionContainer;
var roundImage =
/*#__PURE__*/
(0, _reactEmotion.css)("width:32px;height:32px;border-radius:50%;");
exports.roundImage = roundImage;
var userListContainer =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;position:relative;flex-direction:row;justify-content:space-between;align-items:center;padding:8px 20px 8px 20px;cursor:pointer;width:100%;:hover{background-color:", _themeConfig.default.color.dark.earth, ";}&.onStage{background-color:", _themeConfig.default.color.dark.earth, ";}");
exports.userListContainer = userListContainer;
var onStageSideBar =
/*#__PURE__*/
(0, _reactEmotion.css)("position:absolute;left:0px;height:100%;width:4px;&.ON_STAGE{background-color:", _themeConfig.default.color.dark.emerald, ";}&.INVITED{background-color:", _themeConfig.default.color.dark.topaz, ";}&.REJECTED{background-color:", _themeConfig.default.color.dark.ruby, ";}");
exports.onStageSideBar = onStageSideBar;
var listUserLeftContainer =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;flex-direction:row;align-items:center;position:relative;");
exports.listUserLeftContainer = listUserLeftContainer;
var overlay =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;flex-direction:column;position:absolute;width:100%;height:100%;top:0;left:0;align-items:center;justify-content:center;fill:", _themeConfig.default.color.dark.emerald, ";opacity:0;transition:0.2s cubic-bezier(0.01,0.39,0.99,0.58);&.stage{fill:", _themeConfig.default.color.dark.ruby, ";}:hover{opacity:0.85;background-color:#000000;}.Icon{margin-bottom:3px;}");
exports.overlay = overlay;
var overlayRound =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;position:absolute;width:32px;height:32px;border-radius:50%;top:0;left:0;align-items:center;justify-content:center;fill:", _themeConfig.default.color.dark.emerald, ";opacity:0;transition:0.2s cubic-bezier(0.01,0.39,0.99,0.58);:hover{opacity:0.85;background-color:#000000;}&.stage{fill:", _themeConfig.default.color.dark.ruby, ";}");
exports.overlayRound = overlayRound;
var listNameProgressWrapper =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;flex-direction:column;align-items:flex-start;margin-left:8px;");
exports.listNameProgressWrapper = listNameProgressWrapper;
var listNameProgressTopWrapper =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;flex-direction:row;");
exports.listNameProgressTopWrapper = listNameProgressTopWrapper;
var statusIconClass =
/*#__PURE__*/
(0, _reactEmotion.css)("margin-right:8px !important;");
exports.statusIconClass = statusIconClass;
var listStatusWrapper =
/*#__PURE__*/
(0, _reactEmotion.css)("margin-left:8px;");
exports.listStatusWrapper = listStatusWrapper;
var progressGridContainer =
/*#__PURE__*/
(0, _reactEmotion.css)("position:absolute;display:flex;align-items:center;height:17px;bottom:-1px;background-color:", _themeConfig.default.color.dark.jupiter, ";padding:2px 5px 1px;");
exports.progressGridContainer = progressGridContainer;
var progressListContainer =
/*#__PURE__*/
(0, _reactEmotion.css)("margin-top:4px;");
exports.progressListContainer = progressListContainer;